<template>
  <div class="header-wrapper animate fadeIn">
    <div class="order-detail mb-0">
      <loader v-if="loading"></loader>
      <div class="container" v-if="!loading">
        <h1 class="header-title">รายการที่คุณบริจาค</h1>
        <!-- <ul class="breadcrumb">
          <li class="link"><router-link to="/">หน้าแรก</router-link></li>
          <li class="link"><a href="#/orders">รายการที่คุณบริจาค</a></li>
          <li class="link">รายละเอียดการบริจาค</li>
        </ul> -->
        <div class="block-primary block shadow radius border _clearfix mb-0">
          <div class="row">
            <div class="col-md-8">
              <h2 class="header__bar">
                <span class="col-xs-8 pd-0">เลขที่บริจาค #{{order.order_id}}</span>
                <span class="text-right col-xs-4 pd-0">{{ order.created | datetime }}</span>
              </h2>
              <div class="table-responsive">
                <table id="" class="table table-striped" cellspacing="0" cellpadding="2" style=" " border="1">
                  <thead>
                  <tr>
                      <th class="" scope="col">รายการ</th>
                      <th class="text-right" scope="col"></th>
                      <th class="text-right" scope="col">จำนวนเงิน</th>
                  </tr>
                  </thead>
                  <tbody>
                      <tr v-for="item in order.invoice_product_list" :key="item.product_sku">
                          <td>
                            <router-link :to="{ name: 'product_detail', params: { sku: item.product_sku }}">
                              {{ item.product_name }}
                              <span v-if="item.catalog_sku">({{ item.catalog_name }})</span>
                            </router-link>
                            <br>
                            <!-- <span class="text-muted">{{ (item.product_sub_sku || '').replace(/_/g, ' / ') }}</span> -->
                          </td>
                          <!-- <td class="text-right">{{ item.product_quantity }}</td> -->
                          <td class="text-right"></td>
                          <td class="text-right"><strong>{{ item.product_price | money }}</strong></td>
                      </tr>
                  </tbody>
                  <tfoot>
                      <!-- <tr>
                        <td colspan="2" class="label--light text-right">ยอดรวม:</td>
                        <td class="text-right"><strong>{{ order.total_product_price | money }}</strong></td>
                      </tr> -->
                      <!-- <tr>
                        <td colspan="2" class="label--light text-right">ค่าจัดส่ง:</td>
                        <td class="text-right"><strong>{{ (order.total_shipping_price || 0) | money }}</strong></td>
                      </tr> -->
                      <tr>
                        <td colspan="2" class="label--light text-right">ช่องทางการชำระเงิน:</td>
                        <td class="text-right"><strong>{{ paymentMethod }}</strong></td>
                      </tr>
                      <tr>
                        <td colspan="2" class="label text-right">ยอดรวมทั้งหมด:</td>
                        <td class="text-right"><strong>{{ order.total_price | money }}</strong></td>
                      </tr>
                  </tfoot>
                </table>
              </div><!-- End of table-responsive -->
              <!-- <h2 class="header__bar">
                ที่อยู่สำหรับจัดส่ง
              </h2> -->
              <!-- <div class="border mb-15">
                <div class="pd-15">
                  <div>{{ order.fullname }}</div>
                  <div v-html="$options.filters.newLineToBr(order.address)"></div>
                  <div>{{orderProvince}} {{order.postcode}}</div>
                </div>
                <hr />
              </div> -->
              <h2 class="header__bar">
                ข้อมูลผู้บริจาค
              </h2>
              <div class="pd-15">
                <div><div class="label--light">อีเมล:</div> <a href="mailto:...">{{ order.email }}</a></div>
                <div><div class="label--light">เบอร์ติดต่อ:</div> {{ order.phone_number }}</div>
                <div v-if="order.note"><div class="label">Note:</div> {{ order.note }}</div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="pd-15 block-third mb-15 text-center">
                <div class="label text-center mb-15">สถานะ</div>
                <order-status :order="order"></order-status>
              </div>

              <div class="label pd-15 block-third" v-if="isBankTransfer && !isBankTransferExpired && !isPaid">

                <div v-if="isWaitForApprove">
                  <router-link tag="button" :to="{ name: 'upload-slip', params: { orderId: order.public_order_id || order.order_id } }" class="btn btn--purple btn--center mt-30">ส่งหลักฐานการโอนเงินเพิ่มเติม</router-link>
                  <p class="text-remark text-secondary text-center">กรณีที่ต้องการส่งหลักฐานการโอนเงินใหม่<br/>สามารถส่งได้อีกครั้งที่นี่</p>
                </div>

                <div v-else>
                  <p class="text-muted pd-15">เตรียมหลักฐานการโอนเงินเป็นรูปภาพหรือรูปถ่าย เช่น รูปถ่ายใบเสร็จการโอนเงินจากตู้ ATM หรือรูปภาพหน้าจอในกรณีที่ทำธุรกรรมออนไลน์</p>
                  <router-link tag="button" :to="{ name: 'upload-slip', params: { orderId: order.public_order_id || order.order_id } }" class="btn btn--purple btn--center mt-30">ส่งหลักฐานการโอนเงิน</router-link>
                </div>
              </div>

            </div>

          </div><!-- End of row -->
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Loader from './Loader.vue'
import OrderStatus from './OrderStatus.vue'
import ProductChoiceSummary from './ProductChoiceSummary.vue'

export default {
  components: {
    ProductChoiceSummary,
    OrderStatus,
    Loader},
  name: 'OrderDetail',
  props: {
    id: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      orderId: this.id,
      loading: true,
      order: null
    }
  },
  created () {
    if (!this.orderId) {
      this.orderId = this.$route.params.id
    }
    this.$http.get(`invoices/${this.orderId}`)
      .then(resp => {
        this.loading = false
        this.order = resp.body
      })
      .catch(err => {
        console.log(err)
        this.$utils.showCommonError(() => {
          this.$router.go(this.$router.currentRoute)
        })
      })
  },
  computed: {
    orderProvince () {
      return this.$utils.provincesMap[this.order.province] || this.order.province
    },
    paymentMethod () {
      return this.order && {
        credit_card: 'Credit Card',
        bank_transfer: 'โอนผ่านบัญชีธนาคาร',
        paypal: 'PayPal',
        line_pay: 'Line Pay'
      }[this.order.payment_method]
    },
    isPaid () {
      return this.order.status === 2
    },
    isWaitForApprove () {
      return this.order.status === 1
    },
    isBankTransfer () {
      return this.order.payment_method === 'bank_transfer'
    },
    isBankTransferExpired () {
      return this.isBankTransfer && this.order.status === 3 && this.order.substatus === 5
    }
  }
}
</script>



// WEBPACK FOOTER //
// OrderDetail.vue?91129a32